import PropTypes from 'prop-types';
import React from 'react';

export const PriceIntersectsFirstCandleWrapper = ({
  softOrder,
  Component,
  ...rest
}) => {
  const details = {
    tacticName: 'PRICE_INTERSECTS_FIRST_CANDLE',
    category: 'Setup Filter',
    type: 'Price Intersects First Candle',
    domain: 'Underlying',
  };

  const priceToBreak = softOrder.priceToBreak;
  const candleDuration = softOrder.candleDuration;

  return (
    <Component
      details={details}
      priceToBreak={priceToBreak}
      candleDuration={candleDuration}
      {...rest}
    />
  );
};

PriceIntersectsFirstCandleWrapper.propTypes = {
  Component: PropTypes.any,
  softOrder: PropTypes.shape({
    candleDuration: PropTypes.any,
    priceToBreak: PropTypes.any
  })
};
